import { useMemo } from 'react'

/** @type {import('Simple/types.js').useDataTransform} */
export default function useDataTransform(props, data) {
  return useMemo(
    () => ({
      ...data,
      patient_id: props.patientId,
      default_payment_account_id: props.defaultPaymentAccountId,
      include_person_payors:
        typeof props.includePersonPayors === 'boolean'
          ? props.includePersonPayors
          : data.include_person_payors,
      include_insurance_payors:
        typeof props.includeInsurancePayors === 'boolean'
          ? props.includeInsurancePayors
          : data.include_insurance_payors,
      onChange: props.onChange,
    }),

    [data, props.defaultPaymentAccountId, props.patientId] // eslint-disable-line react-hooks/exhaustive-deps
    // ignore props.onChange
  )
}
